import GestureTapIcon from '~/components/assets/gesture-tap';

export default {
  theme: {
    themes: {
      light: {
        primary: '#3858E0'
      }
    }
  },
  icons: {
    values: {
      'mbz-gesture-tap': {
        component: GestureTapIcon
      }
    }
  },
  breakpoint: {
    thresholds: {
      xs: 768,
      sm: 1024,
      md: 1264,
      lg: 1904
    },
    scrollBarWidth: 0,
    mobileBreakpoint: 'xs'
  }
};
